import ApiResourceManager from '../ApiResourceManager';

export default class MagicLinksManager extends ApiResourceManager {
  create = (data) =>
    this.request({
      method: 'POST',
      url: '/magic-links',
      data,
    });
}
